@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

// Most of this is copied from react-tabs.css

.Tabs {
  @extend %font-family-primary;

  display: flex;
  flex-direction: column;
  font-size: $font-size-normal;
  height: 100%;
  min-height: 22px;

  .TabPanel {
    overflow: hidden;
  }

  .TabPanelSelected {
    flex: 1;
  }

  .TabList {
    display: grid;
    border-bottom: 1px solid $theme-color-borders;
    margin: 0 0 16px;
    padding: 0;
    column-gap: 8px;

    &.templateFlow {
      grid-template-columns: auto auto auto 1fr;
    }

    &.autoFlow {
      grid-auto-flow: column;
    }
  }

  .Tab {
    box-sizing: border-box;
    color: $theme-color-tab-label-unselected;
    display: flex;
    column-gap: 8px;
    align-items: center;
    font-weight: 600;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 16px;
    cursor: pointer;
    min-height: 57px;  // prevent content height shrink, height = 33px (topBottomPadding) + 22px (content) + 2px border
    border-bottom: 2px solid transparent;

    &.hasNoMinHeight {
      min-height: 0px;
    }

    &.autoFlowTabLabel {
      justify-content: center; // labels will align left when there is no trailing space
    }

    .TabLabel {
      display: flex;
      align-items: center;

      &:hover {
        border-radius: 5px 5px 0 0;
        color: $theme-color-tab-label-hover;
        cursor: pointer;
      }
    }
  }

  .DisabledTab {
    color: $theme-color-tab-label-unselected;

    &:hover {
      border-radius: 5px 5px 0 0;
      color: $theme-color-tab-label-unselected;
      cursor: not-allowed;
    }
  }

  .TabSelected,
  .TabSelected:hover {
    border-bottom: 2px solid $color-primary-purple;
    color: $theme-color-tab-label-selected !important;
    cursor: context-menu;
  }

  .TabPanelChildrenBase {
    display: block;
    height: 100%;
  }

  .TabPanelChildrenVisible {
    display: grid;
    overflow-y: auto;
    height: 100%;
  }

  .TabPanelChildrenInvisible {
    display: none;
  }

  .ExternalQueryWrapper {
    padding-right: 16px;
  }

  .ExternalQueryTabWrapper {
    align-self: center;
    box-sizing: border-box;
    color: $theme-color-tab-label-unselected;
    display: flex;
    border-bottom: 2px solid transparent;
    justify-content: flex-end;
  }
}
